var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "layout-base",
        { attrs: { title: _vm.$t("STEP_THREE.TITLE") } },
        [
          _c(
            "template",
            { slot: "content" },
            [
              _c("bk-username", {
                staticClass: "input",
                attrs: {
                  username: _vm.username,
                  state: _vm.usernameState,
                  suggestions: _vm.usernameSuggestions,
                  valid: _vm.usernameValid,
                  id: _vm.usernameId,
                  disabled: _vm.inputDisabled,
                  loading: _vm.usernameLoading,
                  "allow-hotjar-recording": true
                },
                on: {
                  change: _vm.changeUsername,
                  clickSuggestion: function($event) {
                    return _vm.clickSuggestion()
                  }
                }
              }),
              _vm._v(" "),
              _c("bk-password", {
                staticClass: "input",
                attrs: {
                  password: _vm.password,
                  valid: _vm.passwordValid,
                  state: _vm.passwordState,
                  id: _vm.passwordId,
                  disabled: _vm.inputDisabled
                },
                on: { change: _vm.changePassword }
              }),
              _vm._v(" "),
              _c("bk-email", {
                attrs: {
                  email: _vm.email,
                  state: _vm.emailState,
                  valid: _vm.emailValid,
                  id: _vm.emailId,
                  loading: _vm.emailLoading,
                  disabled: _vm.inputDisabled,
                  "allow-hotjar-recording": true
                },
                on: { change: _vm.changeEmail }
              }),
              _vm._v(" "),
              _vm.emailNotAvailable
                ? _c("div", { staticClass: "step3__email-in-use" }, [
                    _c("div", { staticClass: "step3__email-in-use__link" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "https://beta1.bildkontakte.de/de/login"
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("STEP_THREE.IN_USE.LOGIN")))]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "step3__email-in-use__link" }, [
                      _c(
                        "a",
                        {
                          attrs: {
                            href:
                              "https://beta1.bildkontakte.de/de/send-recovery"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("STEP_THREE.IN_USE.RECOVER_PASSWORD"))
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("STEP_THREE.CONDITIONS_AND_PRIVACY.1")) +
                    "\n        "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.bildkontakte.de/pops/agb.php",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("STEP_THREE.CONDITIONS_AND_PRIVACY.2"))
                    )
                  ]
                ),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("STEP_THREE.CONDITIONS_AND_PRIVACY.3")) +
                    "\n        "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.bildkontakte.de/datenschutz",
                      target: "_blank"
                    }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$t("STEP_THREE.CONDITIONS_AND_PRIVACY.4"))
                    )
                  ]
                ),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("STEP_THREE.CONDITIONS_AND_PRIVACY.5")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "hidden",
                  value: "2",
                  id: "termsAndConditionsCheckbox"
                }
              }),
              _vm._v(" "),
              _c("input", {
                attrs: {
                  type: "hidden",
                  value: "2",
                  id: "privacyNoticeCheckbox"
                }
              }),
              _vm._v(" "),
              _c(
                "bk-checkbox",
                {
                  staticClass: "checkbox",
                  attrs: {
                    id: "publicProfileCheckbox",
                    checked: _vm.publicProfile,
                    valid: true
                  },
                  on: { input: _vm.changePublicProfile }
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("STEP_THREE.PUBLIC_PROFILE")) +
                      "\n      "
                  )
                ]
              ),
              _vm._v(" "),
              _vm.error
                ? _c("div", { staticClass: "step3__error" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("STEP_THREE.ERROR", {
                            errorCode: this.errorCode,
                            supportMail: _vm.$t("SUPPORT_MAIL")
                          })
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "buttons" },
            [
              _c(
                "bk-button",
                {
                  attrs: { disabled: !_vm.isFormValid },
                  on: { click: _vm.register }
                },
                [_vm._v(_vm._s(_vm.$t("GLOBAL.DONE")))]
              ),
              _vm._v(" "),
              _c("bk-back-button", {
                attrs: {
                  "track-action": "SingleOptin",
                  "track-label": "Zurueck",
                  to: "/step-two"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "template",
            { slot: "usp" },
            [!_vm.coupon.isEmpty() ? _c("coupon-box") : _vm._e()],
            1
          )
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }